module.exports = __webpack_public_path__ + "static/media/laptop.28f051be.jpg";